import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

export default new VueRouter({
  routes: [
    {
      path: '/',
      redirect: '/public/report',
      children:[
        {
          path: '/user-manager',
          meta: {
            title: '用户管理',
            allowBack: true
          },
          component: () => import('../pages/userManager'),
        },
      ]
    },
    {
      path: '/public',
      meta: {
        title: '内蒙古自治区综检联网平台'
      },
      component: () => import('../pages/public'),
      children: [
        {
          path: 'home',
          component: () => import('../pages/public/home')
        },
        {
          path: 'report',
          component: () => import('../pages/public/report')
        },
        {
          path: 'applicant',
          component: () => import('../pages/public/applicant')
        },
        {
          path: 'announcement',
          component: () => import('../pages/public/announcement')
        }
      ]
    },
    {
      path: '/my-account',
      meta: {
        title: '对账管理',
        allowBack: true
      },
      component: () => import('../pages/myAccount'),
    },
    {
      path: '/recharge-records',
      meta: {
        title: '充值记录',
        allowBack: true
      },
      component: () => import('../pages/rechargeRecords')
    },
    {
      path: '/check-account',
      meta: {
        title: '对账管理',
        allowBack: true
      },
      component: () => import('../pages/checkAccount'),
    },
    {
      path: '/verify-detail',
      meta: {
        title: '综检报告查询',
        allowBack: true
      },
      component: () => import('../pages/verifyDetail'),
    },
    {
      path: '/login',
      meta: {
        title: '登录',
        allowBack: true
      },
      component: () => import('../pages/login')
    },
    {
      path: '/apply',
      meta: {
        title: '申请接入',
        allowBack: true
      },
      component: () => import('../pages/apply')
    },
    {
      path: '/webApply',
      meta: {
        title: '申请接入',
        allowBack: true
      },
      component: () => import('../pages/webApply')
    },
    {
      path: '/apply-result',
      meta: {
        title: '接入结果',
        allowBack: true
      },
      component: () => import('../pages/applyResult')
    },
    {
      path: '/authorize-fail',
      meta: {
        title: '授权失败',
        allowBack: false
      },
      component: () => import('../pages/authorizeFail')
    },
    {
      path: '/applications',
      meta: {
        title: '我的申请',
        allowBack: false
      },
      component: () => import('../pages/applications')
    }
    ,
    {
      path: '/add-user',
      meta: {
        title: '新增账户',
        allowBack: false
      },
      component: () => import('../pages/addUser')
    }
    ,
    {
      path: '/bind-wechat',
      meta: {
        title: '请先扫码',
        allowBack: false
      },
      component: () => import('../pages/bindWechat')
    }
  ]
})